import { IApplicationState } from '../../types/redux';

export const selectOptions = (state: IApplicationState) => state.print.options;
